// Preload on intent (loaded from sections/sivana-brand-styles.liquid): browsers without Speculation Rules
// prefetch a page when a shopper hovers or touches its link, so the click lands on a page that's already
// downloaded. Page-to-page motion is one whole-page fade, in sections/sivana-brand-styles.liquid.
(() => {
  const supportsSpeculation = HTMLScriptElement.supports?.('speculationrules');
  if (!supportsSpeculation) {
    const done = new Set();
    const eligible = (link) => {
      if (!link || !link.href || link.target === '_blank' || link.hasAttribute('download')) return false;
      if (link.closest('[data-no-prefetch]')) return false;
      const url = new URL(link.href, location.href);
      if (url.origin !== location.origin || url.hash && url.pathname === location.pathname) return false;
      return !/^\/(cart|checkout|account|apps|services)/.test(url.pathname) && !url.searchParams.has('variant');
    };
    const prefetch = (link) => {
      const href = link.href.split('#')[0];
      if (done.has(href)) return;
      done.add(href);
      const hint = document.createElement('link');
      hint.rel = 'prefetch';
      hint.href = href;
      document.head.append(hint);
    };
    let timer;
    document.addEventListener(
      'mouseover',
      (event) => {
        const link = event.target.closest?.('a');
        if (!eligible(link)) return;
        clearTimeout(timer);
        timer = setTimeout(() => prefetch(link), 65);
      },
      { passive: true }
    );
    document.addEventListener('mouseout', () => clearTimeout(timer), { passive: true });
    document.addEventListener(
      'touchstart',
      (event) => {
        const link = event.target.closest?.('a');
        if (eligible(link)) prefetch(link);
      },
      { passive: true }
    );
  }
})();
